import { useSelector } from "react-redux";
import { selectCurrentDoctorInfo } from "../../../store/authSlice";
import { Navigate } from "react-router-dom";
import Signup from ".";

export default function SignupRouteGuard() {
  const doctorInfo = useSelector(selectCurrentDoctorInfo);

  // If doctor is verified and logged in, redirect them
  if (doctorInfo?._id && doctorInfo?.isVerified) {
    return <Navigate to="/doctor" replace />;
  }

  // Allow signup
  return <Signup />;
}
